import { useEffect } from 'react';
import { TextLayerExtension } from '@meitu/saas-editor-core/es/editor/layer-extensions/text-layer';
import { TextEditPlugin } from '@meitu/saas-editor-core/es/plugins/text-edit';
import { LayerType, type ITextLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { useEditor } from '@/hooks/use-editor';
import { useStore } from '../store';

export const useShapeTextCache = (layerId: string) => {
    const editor = useEditor();
    const setShapeExtensionCache = useStore((state) => state.setShapeExtensionCache);

    // 初始化
    useEffect(() => {
        const layer = editor.active.getPick();
        if (!layer || layer.layerType !== LayerType.TEXT_LAYER) return;

        const layerData = layer.data as ITextLayerProps;
        const { shapeExtension } = layerData;

        setShapeExtensionCache(shapeExtension ? shapeExtension : null);
    }, [layerId]);

    useEffect(() => {
        // 监听进入编辑态
        const disposeSpyOnEnterEditing = editor.getInstance(TextEditPlugin).onBeforeEnterEditing((layer) => {
            if (layer.layerType !== LayerType.TEXT_LAYER || layer.id !== layerId) return;

            const layerData = layer.data as ITextLayerProps;
            const { shapeExtension } = layerData;

            setShapeExtensionCache(shapeExtension ? shapeExtension : null);
        });

        // 监听取消
        const disposeSpyOnCancel = editor.getInstance(TextLayerExtension).onCancelShapeText((layer) => {
            if (layer.id !== layerId) return;

            setShapeExtensionCache(null);
        });

        return () => {
            disposeSpyOnEnterEditing();
            disposeSpyOnCancel();

            setShapeExtensionCache(null);
        };
    }, []);
};
